// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__jY6rO","loaderOuter":"PageOverlayLoader_loaderOuter__1CgpG"};